import { AuthStorage, PluggableStorage } from '@frontend/auth-helpers';

/**
 * Ephemeral OIDC PKCE state for the authorization code flow. Uses sessionStorage so each
 * tab keeps its own code_verifier/state_nonce and they are cleared when the tab closes.
 */
export const oidcSessionStore = PluggableStorage.create('oidc', sessionStorage);

export const OIDC_SESSION_KEYS = {
  codeVerifier: AuthStorage.oidc_code_verifier,
  stateNonce: AuthStorage.oidc_state_nonce,
  csrfRecoveryAttempts: AuthStorage.oidc_csrf_recovery_attempts,
} as const;
